import axios from 'axios';
import router from '@/router';  // 引入router
import { Vue } from 'vue-property-decorator';

// 配置请求头信息。
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
export function post(url: any, data: any) {
  const param = {
    ...data,
  };

  const prexStr = '/api/';
  const methodType = 'post';
    // let console: Console;
  return axios[methodType](prexStr + url, param).then((response: any) => {
    
    // 如果session过期，则跳转到登录页面
    if (response.data.code == 300) {
      Vue.prototype.$message.error(response.data.message);
      // console.error(response.data.message);
      return ;
    }
    return response.data;

  }).catch((error: any) => {
    switch (error.response.status) {
      case 400:
        console.log('请求错误');
        break;
      case 401:
        console.log('未授权，请登录');
        break;
      case 403:
        console.log('拒绝访问');
        break;
      case 404:
        console.log('请求未找到');
        break;
      case 408:
        console.log('请求超时');
        break;
      case 500:
        console.log('服务器内部错误');
        break;
      case 501:
        console.log('服务未实现');
        break;
      case 502:
        console.log('网关错误');
        break;
      case 503:
        console.log('服务不可用');
        break;
      case 504:
        console.log('网关超时');
        break;
      case 505:
        console.log('HTTP版本不手支持');
        break;
    }

  });
}
